import React, { useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import ReactTable from "../../../../../lib/table/react-table";
import { findIcon } from "../../../../dashboard/icons";
import TreeMapChart from "../../../../../components/chart/TreeMapChart";
import BarChart from "../../../../../components/chart/BarChart";
import BoxPlotChart from "../../../../../components/chart/BoxPlotChart";
import SparlLineBar from "../../../../../components/chart/SparlLineBar";
import TableHeaderSwiper from "../components/TableHeaderSwiper";
import {
  useGetCreativeDeviceLatencyReport,
  useGetCreativeDimensionReport,
  useGetCreativeReportTableData,
  useGetCreativeReportTableDataCtr,
  useGetOsLatencyReport,
  useGetSummaryCampaignGroupList,
  useGetSummaryCreativeList,
} from "../../../../../queries/query-hooks/workspace/brand-ads-hook";
import {
  formatLocalizedDate,
  titleCase,
  transformGraphData,
} from "../../../../../common/utils/utils";
import CommonTableLoader from "../../../../../skeleton/common-table-loader";
import SquareChartSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/square-chart-skeleton";
import BarChartSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/bar-chart-skeleton";
import NavSwiperSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/nav-swiper-skeleton";
import PageNotFound from "../../../../PageNotFound";
import { fallbackImages } from "../../../../../utilities/fallback-images";
import { useParams } from "react-router-dom";
import useRedirect from "../../../../../components/custom-hooks/use-redirect";
import { useGetProjectDetails } from "../../../../../queries/query-hooks/workspace/workspace-hook";
import useCsvDownloader from "../../../../../components/custom-hooks/use-csv-downloader";
import * as dayjs from "dayjs";
import { ProjectHeaderTopBar, TableHeader } from "@ui";
import ProjectFilters from "../components/ProjectFilters";
import { useDispatch, useSelector } from "react-redux";
import { selectProject } from "store/project/project.selector";
import { updateProject } from "store/project/project.action";
import ReactPlayer from "react-player";

const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function Creative() {
  const { redirectTo } = useRedirect();
  const { project_id } = useParams();
  const dispatch = useDispatch();
  const project = useSelector(selectProject);
  const { downloadCSV } = useCsvDownloader();

  const [activeCampaignGroup, setActiveCampaignGroup] = useState({});

  function getGroupIdsCommaSeparated(data) {
    return data.map((item) => item.group_id).join(",");
  }

  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id);

  const [dateRangePayload, setDateRangePayload] = useState({
    start_date: "",
    end_date: "",
  });
  const [isProjectChange, setIsProjectChange] = useState(false);

  useEffect(() => {
    setIsProjectChange(true);
  }, [project_id]);

  const { data: creativeDataReport, isLoading: isLoadingCreativeDataReport } =
    useGetCreativeReportTableData(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list: activeCampaignGroup?.id,
      },
      activeCampaignGroup?.id &&
        !!dateRangePayload.start_date &&
        !!dateRangePayload.end_date
        ? true
        : false
    );
  const {
    data: creativeDataReportCtr,
    isLoading: isLoadingCreativeDataReportCtr,
  } = useGetCreativeReportTableDataCtr(
    project_id,
    {
      start_date: dateRangePayload.start_date,
      end_date: dateRangePayload.end_date,
      campaign_list: activeCampaignGroup?.id,
    },
    activeCampaignGroup?.id &&
      !!dateRangePayload.start_date &&
      !!dateRangePayload.end_date
      ? true
      : false
  );

  const { data: creativeDataList, isLoading: isCreativeDataListLoading } =
    useGetSummaryCreativeList(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );
  const { data: deviceLatencyReport, isLoading: isLoadingDeviceLAtency } =
    useGetCreativeDeviceLatencyReport(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const { data: dimensionReport, isLoading: isDimensionLoading } =
    useGetCreativeDimensionReport(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const { data: osLatencyReport, isLoading: isOsLatencyLoading } =
    useGetOsLatencyReport(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const { data: campaignGroupList, isLoading: isCampaignGroupListLoading } =
    useGetSummaryCampaignGroupList(project_id, {
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    });

  const TableColumnData = [
    {
      Header: "Thumbnail",
      columnId: 1,
      accessor: "file",
      disableFilters: true,
      Cell: ({ value, row }) => {
        return row.original.type == "image" ? (
          <a
            target="_blank"
            alt="thumbnail"
            rel="noopener noreferrer"
            href={value}
          >
            <img
              // onClick={() =>
              //   redirectTo(
              //     `brand-ads/creative/details/${project_id}/${row.original.creative_id}/${row.original.campaign_id}`
              //   )
              // }
              src={value}
              className="rounded-3 border border-1 cursor-pointer"
              style={{ maxWidth: "12rem", height: "auto" }}
            />
          </a>
        ) : row.original.type == "video" ? (
          <div
            onClick={() =>
              redirectTo(
                `brand-ads/creative/details/${project_id}/${row.original.creative_id}/${row.original.campaign_id}`
              )
            }
            className="cursor-pointer"
          >
            {/* <video
              // onClick={() =>
              //   redirectTo(
              //     `brand-ads/creative/details/${project_id}/${row.original.creative_id}/${row.original.campaign_id}`
              //   )
              // }
              autoPlay
              loop
              src={value}
              target="_blank"
              alt="thumbnail"
              rel="noopener noreferrer"
              className="rounded-3 border border-1 cursor-pointer"
              style={{ maxWidth: "10rem", height: "auto" }}
            /> */}
            <ReactPlayer
              url={value}
              playing
              loop
              className="rounded-3 border border-1 cursor-pointer d-flex align-items-center justify-content-center"
              height={"auto"}
              width={"10rem"}
              style={{
                borderRadius: "0.5rem",
                overflow: "hidden",
              }}
            />
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      Header: "Type",
      columnId: 2,
      accessor: "type",
      disableFilters: true,
      Cell: ({ value }) => `${value ? titleCase(value) : 0}`,
    },
    {
      Header: "Dimension",
      columnId: 3,
      accessor: "dimension",
      disableFilters: true,
      Cell: ({ row }) =>
        `${row.original.creative_width} x ${row.original.creative_height}`,
    },
    {
      Header: "Viewed",
      columnId: 4,
      accessor: "views",
      disableFilters: true,
      Cell: ({ value }) => `${value ? value : 0}`,
    },
    // {
    //   Header: "Mobile Impr.",
    //   columnId: 5,
    //   accessor: "mobile_imp",
    //   disableFilters: true,
    //   Cell: ({ value }) => `${value ? value : 0}`,
    // },
    // {
    //   Header: "Web Impr. (%)",
    //   columnId: 6,
    //   accessor: "web_imp_pct",
    //   disableFilters: true,
    //   Cell: ({ value }) => `${value ? value : 0}`,
    // },
    // {
    //   Header: "Total Impr.",
    //   columnId: 7,
    //   accessor: "total_impr",
    //   disableFilters: true,
    //   Cell: ({ value }) => `${value ? value : 0}`,
    // },
    {
      Header: "Total CTR (%)",
      columnId: 8,
      accessor: "ctr",
      disableFilters: true,
      Cell: ({ value }) => `${value ? `${value} %` : "0 %"}`,
    },
    // {
    //   Header: "Trends",
    //   columnId: 9,
    //   accessor: "date_Data",
    //   disableFilters: true,
    //   Cell: ({ cell: { value } }) => {
    //     if (value && value.split(",")?.length > 0) {
    //       return (
    //         <SparlLineBar
    //           series={value?.split(",") || []}
    //           labels={DAYS_OF_WEEK}
    //           height={50}
    //         />
    //       );
    //     } else {
    //       return "N/A";
    //     }
    //   },
    // },
    // {
    //   Header: "Actions",
    //   Cell: ({ row }) => {
    //     const redirectURL = `brand-ads/creative/details/${project_id}/${row.original.creative_id}/${row.original.campaign_id}`;
    //     return (
    //       <Button
    //         className="btn btn-sm rounded-pill"
    //         onClick={() => redirectTo(redirectURL)}
    //       >
    //         {findIcon("Eye", "solid", 16)}
    //       </Button>
    //     );
    //   },
    // },
    {
      Header: "Actions",
      columnId: 9,
      Cell: ({ row }) => {
        const { values } = row;
        const redirectURL = `brand-ads/creative/details/${project_id}/${row.original.creative_id}/${row.original.campaign_id}`;
        return (
          <Button
            className="btn btn-sm rounded-pill"
            onClick={() => redirectTo(redirectURL)}
          >
            {findIcon("Eye", "solid", 16)}
          </Button>
        );
      },
    },
  ];

  function formatDimensionData(inputArray) {
    return inputArray.map(({ Dimensions, dimension_count }) => ({
      x: Dimensions,
      y: dimension_count,
    }));
  }

  const dimentionChartData =
    dimensionReport && dimensionReport?.length > 0
      ? formatDimensionData(dimensionReport)
      : [];

  const deviceLatencyChartData = {
    series:
      deviceLatencyReport && deviceLatencyReport?.length > 0
        ? transformGraphData(deviceLatencyReport, "avg_latency", "Device")
            ?.series
        : [],
    labels:
      deviceLatencyReport && deviceLatencyReport?.length > 0
        ? transformGraphData(deviceLatencyReport, "avg_latency", "Device")
            ?.label
        : [],
  };

  function formatOsChartData(inputArr) {
    if (inputArr?.length < 0) {
      return [];
    } else {
      return inputArr.map((item) => ({
        x: item.os_name == null ? "Others" : item.os_name,
        y: [item.minimum, item.Q1, item.median, item.Q3, item.maximum],
      }));
    }
  }

  const OperatingSystemChartData =
    osLatencyReport && osLatencyReport?.length > 0
      ? formatOsChartData(osLatencyReport)
      : [];

  function mergedCreativeData(creativeList, creativeReport, creativeReportCtr) {
    if (
      creativeList &&
      creativeList?.length > 0 &&
      !Array.isArray(creativeReport) &&
      !Array.isArray(creativeReportCtr)
    ) {
      return creativeList.map((items) => ({
        ...items,
        views: "loading",
        unique_clicks: "loading",
        ctr: "loading",
      }));
    }

    if (
      creativeList &&
      creativeList?.length > 0 &&
      creativeReport &&
      creativeReport?.length > 0
    ) {
      var mergedData = creativeList.map((items) => {
        const matchingMatrix = creativeReport.find(
          (matrix) => matrix.creative_id == items.creative_id
        );

        const matchingCtr =
          creativeReportCtr && Array.isArray(creativeReportCtr)
            ? creativeReportCtr.find(
                (matrix) => matrix.creative_id == items.creative_id
              )
            : [];

        return {
          ...items,
          ...(matchingMatrix || {}),
          ...(matchingCtr || {}),
          campaign_id: activeCampaignGroup?.id,
        };
      });

      mergedData = mergedData.map((item) => {
        return {
          ...item,
          dimention_str: `${item.creative_width} x ${item.creative_height}`,
        };
      });

      return mergedData && Array.isArray(mergedData)
        ? mergedData.sort((a, b) => b.views - a.views)
        : [];
    }

    if (
      creativeList &&
      creativeList?.length > 0 &&
      creativeReport &&
      creativeReport?.length > 0 &&
      creativeReportCtr &&
      creativeReportCtr?.length > 0
    ) {
      const mergedData = creativeList.map((items) => {
        const matchingMatrix = creativeReport.find(
          (matrix) => matrix.creative_id == items.creative_id
        );
        const matchingCtr = creativeReportCtr.find(
          (matrix) => matrix.creative_id == items.creative_id
        );

        return {
          ...items,
          ...(matchingMatrix || {}),
          ...(matchingCtr || {}),
          campaign_id: activeCampaignGroup?.id,
        };
      });
      mergedData =
        mergedData && Array.isArray(mergedData)
          ? mergedData
              .map((item) => {
                return {
                  ...item,
                  dimention_str: `${item.creative_width} x ${item.creative_height}`,
                };
              })
              .sort((a, b) => b.views - a.views)
          : [];

      return mergedData;
    }

    return creativeList && Array.isArray(creativeList)
      ? creativeList.sort((a, b) => b.views - a.views)
      : creativeList;
  }

  const creativeTableData = mergedCreativeData(
    creativeDataList,
    creativeDataReport,
    creativeDataReportCtr
  );

  const tableCsvFormat = {
    header: [
      "Thumbnail",
      "Creative Type",
      "Dimension",
      "Viewed",
      // "Mobile imp",
      // "Web impr",
      // "Total impr",
      "Total CTR (%)",
    ],
    column: [
      "file",
      "type",
      "dimention_str",
      "views",
      // "mobile_imp",
      // "web_imp_pct",
      // "total_impr",
      "ctr",
    ],
    // chart: {
    //   header: "Trends",
    //   column: "date_Data",
    // },
    rows: creativeTableData,
  };

  useEffect(() => {
    if (projectDetails && projectDetails?.length > 0) {
      const today = dayjs();
      const projectEndDate = dayjs(projectDetails[0]?.project_end_date);
      let result = projectDetails[0]?.project_end_date;

      if (
        projectEndDate &&
        (projectEndDate.isAfter(today) || projectEndDate.isSame(today, "day"))
      ) {
        result = today.subtract(1, "day");
      } else {
        result = projectEndDate;
      }

      if (project?.start_date && project?.end_date && !isProjectChange) {
        setDateRangePayload({
          start_date: project?.start_date,
          end_date: project?.end_date,
        });
        dispatch(
          updateProject({
            start_date: project?.start_date,
            end_date: project?.end_date,
          })
        );
      } else {
        setDateRangePayload({
          start_date: formatLocalizedDate(
            new Date(projectDetails[0]?.project_start_date),
            "YYYY-MM-DD[T]00:00:00.000Z"
          ),
          end_date: formatLocalizedDate(
            new Date(result),
            "YYYY-MM-DD[T]23:59:59.000Z"
          ),
        });
        dispatch(
          updateProject({
            start_date: formatLocalizedDate(
              new Date(projectDetails[0]?.project_start_date),
              "YYYY-MM-DD[T]00:00:00.000Z"
            ),
            end_date: formatLocalizedDate(
              new Date(result),
              "YYYY-MM-DD[T]23:59:59.000Z"
            ),
          })
        );
        setIsProjectChange(false);
      }
    }
  }, [projectDetails, project_id]);

  const allPerformanceDataLoaded =
    !isLoadingDeviceLAtency && !isDimensionLoading;

  const performanceCharts = [
    // {
    //   key: "deviceLatency",
    //   hasData: deviceLatencyReport?.length > 0,
    //   element: (
    //     <BarChart
    //       title="Device Latency"
    //       series={deviceLatencyChartData.series}
    //       labels={deviceLatencyChartData.labels}
    //       name="ms"
    //     />
    //   ),
    // },
    {
      key: "dimension",
      hasData: dimensionReport?.length > 0,
      element: <TreeMapChart title="Dimensions" series={dimentionChartData} />,
    },
  ].filter((chart) => chart.hasData);

  const performanceColClass =
    {
      1: "col-12",
      2: "col-md-6 col-sm-12",
    }[performanceCharts.length] || "col-md-6 col-sm-12";

  return (
    <div className="row">
      <div className="col-sm-12">
        <ProjectHeaderTopBar
          projectType="Brand Ads"
          title="Creative"
          projectStartDate={
            projectDetails?.length > 0
              ? projectDetails[0]?.project_start_date
              : ""
          }
          projectEndDate={
            projectDetails?.length > 0
              ? projectDetails[0]?.project_end_date
              : ""
          }
          isProjectDetailsLoading={isProjectDetailsLoading}
          rightComponent={
            <ProjectFilters
              title="Creative"
              dateLabel={dateRangePayload}
              setDateRangePayload={setDateRangePayload}
              projectStartDate={
                projectDetails?.length > 0
                  ? projectDetails[0]?.project_start_date
                  : ""
              }
              projectEndDate={
                projectDetails?.length > 0
                  ? projectDetails[0]?.project_end_date
                  : ""
              }
              isProjectDetailsLoading={isProjectDetailsLoading}
            />
          }
        />
      </div>

      <div className="col-sm-12">
        <Card>
          <TableHeader
            leftComponent={
              !isCampaignGroupListLoading && campaignGroupList.length > 0 ? (
                <TableHeaderSwiper
                  title={campaignGroupList}
                  activeCampaignGroup={activeCampaignGroup}
                  setActiveCampaignGroup={setActiveCampaignGroup}
                  className={"w-75"}
                />
              ) : (
                <NavSwiperSkeleton />
              )
            }
            downloadProps={{
              needCsvDownload:
                !isLoadingCreativeDataReport &&
                creativeDataReport?.length > 0 &&
                creativeTableData?.length > 0,
              exportCSVHandler: () => downloadCSV(tableCsvFormat),
            }}
          />

          <Card.Body>
            {!isProjectDetailsLoading &&
            !isLoadingCreativeDataReport &&
            creativeDataList?.length > 0 ? (
              <ReactTable
                data={creativeTableData}
                columns={TableColumnData}
                isPaginationShow={false}
                bordered
                noDataText="no data"
                noDataImage={fallbackImages.noActionData}
                contentCenter={true}
              />
            ) : isProjectDetailsLoading || isLoadingCreativeDataReport ? (
              <CommonTableLoader tableRowLength={5} />
            ) : null}
          </Card.Body>
        </Card>
      </div>

      {allPerformanceDataLoaded ? (
        performanceCharts.length > 0 ? (
          <div className="row">
            {performanceCharts.map((chart) => (
              <div key={chart.key} className={`mb-4 ${performanceColClass}`}>
                {chart.element}
              </div>
            ))}
          </div>
        ) : null
      ) : (
        <div className="row">
          {[...Array(1)].map((_, i) => (
            <div key={i} className="col-sm-12 mb-4">
              <SquareChartSkeleton />
            </div>
          ))}
        </div>
      )}

      {/* <div className="mb-4 col-sm-12">
        {!isOsLatencyLoading && osLatencyReport?.length > 0 ? (
          <BoxPlotChart
            series={OperatingSystemChartData}
            title={"Operating System Latency"}
          />
        ) : isOsLatencyLoading ? (
          <BarChartSkeleton />
        ) : null}
      </div> */}
    </div>
  );
}

export default Creative;
